import { useSuspenseQueries } from "@tanstack/react-query";
import { getAutoLoanProductsQueryOptions } from "@lending/hooks/queries/AutoLoanProduct/useGetAutoLoanProductsQuery";
import { getCreditCardProductsQueryOptions } from "@lending/hooks/queries/CreditCardProduct/useGetCreditCardProductsQuery";
import { getEligibilityCriteriaQueryOptions } from "@lending/hooks/queries/EligibilityCriteria/useGetEligibilityCriteriaQuery";
import { getPersonalLoanProductsQueryOptions } from "@lending/hooks/queries/PersonalLoanProduct/useGetPersonalLoanProductsQuery";
import { useApi } from "@lending/lib/api";

function useGetProductSelectionDataQuery() {
  const $api = useApi();

  const [
    creditCardProductsQuery,
    personalLoanProductsQuery,
    autoLoanProductsQuery,
    eligibilityCriteriaQuery,
  ] = useSuspenseQueries({
    queries: [
      getCreditCardProductsQueryOptions($api),
      getPersonalLoanProductsQueryOptions($api),
      getAutoLoanProductsQueryOptions($api),
      getEligibilityCriteriaQueryOptions($api),
    ],
  });

  return {
    creditCardProductsData: creditCardProductsQuery.data,
    personalLoanProductsData: personalLoanProductsQuery.data,
    autoLoanProductsData: autoLoanProductsQuery.data,
    eligibilityCriteriaData: eligibilityCriteriaQuery.data,
    hasEligibilityCriteria: eligibilityCriteriaQuery.data.count > 0,
  };
}

export { useGetProductSelectionDataQuery };
